import { z } from 'zod';

const FormSchema = z.object({
  types: z.array(z.enum(['corrective', 'preventive'])).min(1, 'Campo obrigatório'),
  vehicleId: z.string().min(1, 'Campo obrigatório'),
  occurrenceAt: z.string().min(1, 'Campo obrigatório'),
  totalPrice: z
    .number()
    .optional()
    .refine((value) => value === undefined || value >= 0, {
      message: 'O preço não pode ser negativo',
    }),
  odometerInKms: z.string().min(1, 'Campo obrigatório'),
  parts: z
    .array(
      z.object({
        partId: z.string().min(1, 'Campo obrigatório'),
        name: z.string().min(1, 'Campo obrigatório'),
        price: z
          .number()
          .optional()
          .refine((value) => value === undefined || value >= 0, {
            message: 'O preço não pode ser negativo',
          }),
        quantity: z
          .number()
          .optional()
          .superRefine((value, ctx) => {
            if (value !== undefined) {
              if (!Number.isInteger(value)) {
                ctx.addIssue({
                  code: z.ZodIssueCode.custom,
                  message: 'A quantidade deve ser um número inteiro',
                });
              }
              if (value < 0) {
                ctx.addIssue({
                  code: z.ZodIssueCode.custom,
                  message: 'A quantidade não pode ser negativa',
                });
              }
            }
          }),
        description: z.string().optional(),
      })
    )
    .optional(),
  recurrencesHasDone: z.array(z.string()).optional(),
  description: z.string().optional(),
});

type FormValues = z.infer<typeof FormSchema>;

export { FormSchema, type FormValues };
